import { useState, useCallback } from "react";
import { toastService } from "../../../providers";

export const useTransactionDetailsModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [transaction, setTransaction] = useState(null);
  const openModal = useCallback((row) => {
    if (!row || Object.keys(row).length === 0) {
      toastService.error(
        "Cannot open details modal: invalid transaction data.",
      );
      return;
    }
    setTransaction(row);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    transaction,
    openModal,
    closeModal,
  };
};

export default useTransactionDetailsModal;
